import type { ReactElement } from "react";

export const HOVER_DOT_ARIA_LABEL = "hover-dot";

export interface HoverPoint {
  color: string;
  x: number;
  y: number;
}

type LayerComponent = () => ReactElement | null;
type LayerComponentWithName = LayerComponent & { displayName?: string };

export const buildHoverDotLayer = (
  hoverPoint: HoverPoint | null,
): LayerComponentWithName => {
  const HoverDotLayer: LayerComponentWithName = (): ReactElement | null => {
    if (!hoverPoint) return null;
    return (
      <g aria-label={HOVER_DOT_ARIA_LABEL}>
        <circle
          cx={hoverPoint.x}
          cy={hoverPoint.y}
          r={4}
          fill={hoverPoint.color}
          stroke="#ffffff"
          strokeWidth={2}
        />
      </g>
    );
  };
  HoverDotLayer.displayName = "HoverDotLayer";
  return HoverDotLayer;
};
